<template>
  <el-form-item label="显示">
    <el-switch v-model="prop.yAxisShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="显示标题">
    <el-switch v-model="prop.showYAxisName" @change="closeYName()" size="small">
    </el-switch>
  </el-form-item>
  <el-form-item label="标题" v-if="prop.showYAxisName">
    <el-input v-model="prop.yAxisName" size="small"></el-input>
  </el-form-item>
  <el-form-item :label="`标题${isSub ? '左' : '右'}边距`" v-if="prop.showYAxisName">
    <el-input-number v-if="isSub" v-model="prop.yAxisNameLeft" size="small" controls-position="right">
    </el-input-number>
    <el-input-number v-else v-model="prop.yAxisNameRight" size="small" controls-position="right">
    </el-input-number>
  </el-form-item>
  <el-form-item label="标题下边距" v-if="prop.showYAxisName">
    <el-input-number v-model="prop.yAxisNameBottom" size="small" controls-position="right">
    </el-input-number>
  </el-form-item>
  <el-form-item label="标题字体">
    <el-select v-model="prop.yAxisNameFontFamily" size="small">
      <el-option label="微软雅黑" value="Microsoft YaHei"></el-option>
      <el-option label="宋体" value="SimSun"></el-option>
      <el-option label="黑体" value="SimHei"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="标题字号">
    <el-input-number v-model="prop.yAxisNameFontSize" size="small" controls-position="right">
    </el-input-number>
  </el-form-item>
  <el-form-item label="标题字色">
    <colorPicker v-model="prop.yAxisNameColor"></colorPicker>
  </el-form-item>
  <el-form-item label="显示轴标签">
    <el-switch v-model="prop.yAxisLabelShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="轴标签字体">
    <el-select v-model="prop.yAxisFontFamily" size="small">
      <el-option label="微软雅黑" value="Microsoft YaHei"></el-option>
      <el-option label="宋体" value="SimSun"></el-option>
      <el-option label="黑体" value="SimHei"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="轴标签旋转">
    <el-input-number v-model="prop.yAxisRotate" size="small" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="轴标签字号">
    <el-input-number v-model="prop.yAxisFontSize" size="small" controls-position="right">
    </el-input-number>
  </el-form-item>
  <el-form-item label="轴标签字色">
    <colorPicker v-model="prop.yAxisColor"></colorPicker>
  </el-form-item>
  <el-form-item label="显示轴线">
    <el-switch v-model="prop.yAxisLineShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="轴线粗细">
    <el-input-number v-model="prop.yAxisLineWidth" size="small" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="轴线颜色">
    <colorPicker v-model="prop.yAxisLineColor"></colorPicker>
  </el-form-item>
  <template v-if="!isRadar">
    <el-form-item label="最小数值">
      <div class="checkboxAndNumber">
        <el-checkbox v-model="prop.yAxisMinAuto" label="自动"/>
        <div style="width: 16px;"></div>
        <el-input-number v-model="prop.yAxisMin" size="small" controls-position="right"></el-input-number>
      </div>
    </el-form-item>
    <el-form-item label="最大数值">
      <div class="checkboxAndNumber">
        <el-checkbox v-model="prop.yAxisMaxAuto" label="自动"/>
        <div style="width: 16px;"></div>
        <el-input-number v-model="prop.yAxisMax" size="small" controls-position="right"></el-input-number>
      </div>
    </el-form-item>
  </template>
  <template v-else>
    <el-form-item label="轴刻度自定义">
      <el-button size="small" type="primary" @click="openAxisInterval">配置</el-button>
    </el-form-item>
  </template>
  <el-form-item label="数值间距">
    <div class="checkboxAndNumber">
      <el-checkbox v-model="prop.yAxisIntervalAuto" label="自动"/>
      <div style="width: 16px;"></div>
      <el-input-number v-model="prop.yAxisInterval" :min="0" size="small" controls-position="right"></el-input-number>
    </div>
  </el-form-item>
  <el-form-item label="最小间距">
    <el-input-number v-model="prop.yAxisminInterval" :min="0" size="small" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="显示网格线">
    <el-switch v-model="prop.yAxisSplitLineShow" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="开启网格虚线">
    <el-switch v-model="prop.yAxisSplitLineShowDotted" size="small">
    </el-switch>
  </el-form-item>
  <template v-if="prop.yAxisSplitLineShowDotted">
    <el-form-item label="实线宽度">
      <el-input-number
          v-model="prop.yAxisSplitLineOne"
          size="small"
          controls-position="right"
      ></el-input-number>
    </el-form-item>
    <el-form-item label="间隔宽度">
      <el-input-number
          v-model="prop.yAxisSplitLineTwo"
          size="small"
          controls-position="right"
      ></el-input-number>
    </el-form-item>
  </template>
  <el-form-item label="网格线粗细">
    <el-input-number v-model="prop.yAxisSplitLineWidth" size="small" controls-position="right"></el-input-number>
  </el-form-item>
  <el-form-item label="网格线颜色">
    <colorPicker v-model="prop.yAxisSplitLineColor"></colorPicker>
  </el-form-item>
  <el-form-item label="显示参考线">
    <el-switch v-model="prop.yAxisMarkLineShow" size="small"></el-switch>
  </el-form-item>
  <template v-if="prop.yAxisMarkLineShow">
    <el-form-item label="参考线线型">
      <el-select v-model="prop.yAxisMarkLineType" size="small">
        <el-option label="实线" value="solid"></el-option>
        <el-option label="虚线" value="dashed"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="参考线粗细">
      <el-input-number v-model="prop.yAxisMarkLineWidth" size="small" controls-position="right"></el-input-number>
    </el-form-item>
    <el-form-item label="参考线颜色">
      <colorPicker v-model="prop.yAxisMarkLineColor"></colorPicker>
    </el-form-item>
    <el-form-item label="参考线">
      <el-link @click="openReference" type="primary" class="fs-16" :icon="Edit"></el-link>
    </el-form-item>
    <div class="pl-20 pr-20">
      <el-table :data="main.activeOption?.[isSub ? 'rightReferenceCustomSet' : 'referenceCustomSet'] || []"
                row-class-name="tableRow">
        <el-table-column prop="name" label="参考线名"/>
        <el-table-column prop="value" label="参考线值">
          <template v-slot="{ row, $index }">
          <span v-if="row.type === 'dynamic'">
            {{ symbolKind.find(el => el.value === row.valueType).label }}
          </span>
            <span v-else>{{ row.value }}</span>
          </template>
        </el-table-column>
        <!--      <el-table-column label="操作">-->
        <!--        <template #default="scope">-->
        <!--          <el-button link type="primary" size="small" @click="deleteRef(scope)">删除</el-button>-->
        <!--        </template>-->
        <!--      </el-table-column>-->
      </el-table>
      <!--    <el-button style="width: 100%" @click="dialogFormVisible = true" color="#000">新增</el-button>-->
    </div>
  </template>
  <el-form-item label="反转">
    <el-switch v-model="prop.yAxisInverse" size="small"></el-switch>
  </el-form-item>
  <el-form-item label="辅助线条数">
    <el-input-number v-model="prop.yAxisMarkLine" size="small" controls-position="right">
    </el-input-number>
  </el-form-item>
  <el-form-item label="辅助线名称">
    <div style="display: flex; align-items: center;width: 100%">
      <el-input v-model="prop.yAxisMarkName" size="small"></el-input>
      <div style="width: 16px;"></div>
      <el-tooltip class="item" effect="dark" content="注:辅助线名称使用英文,隔开，请保持字数和条数设置一致"
                  placement="top-start">
        <el-icon>
          <QuestionFilled color="#ffffff"/>
        </el-icon>
      </el-tooltip>
    </div>
  </el-form-item>
  <el-form-item label="辅助线值">
    <div style="display: flex; align-items: center;width: 100%">
      <el-input v-model="prop.yAxisMarkValue" size="small"></el-input>
      <div style="width: 16px;"></div>
      <el-tooltip class="item" effect="dark" content="注:辅助线值使用英文,隔开，请保持字数和条数设置一致"
                  placement="top-start">
        <el-icon>
          <QuestionFilled color="#ffffff"/>
        </el-icon>
      </el-tooltip>
    </div>
  </el-form-item>
  <el-dialog draggable v-model="dialogFormVisible" title="参考线配置" width="840">
    <RefSet :isSub="isSub" ref="refSet" v-if="dialogFormVisible" :main="main"></RefSet>
    <template #footer>
      <span class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="save">确认</el-button>
      </span>
    </template>
  </el-dialog>
  <el-dialog draggable v-model="showAxisInterval" title="刻度轴自定义" align-center append-to-body width="600">
    <RaderSet ref="radarSet" v-if="showAxisInterval" :main="main"></RaderSet>
    <template v-slot:footer>
      <el-button @click="showAxisInterval = false">取消</el-button>
      <el-button type="primary" @click="handleOkClick">保存</el-button>
    </template>
  </el-dialog>
</template>
<script setup>
import {QuestionFilled, Edit} from "@element-plus/icons-vue";
import colorPicker from "./color-picker.vue";
import {ref} from "vue";
import RefSet from "./referenceCustomSet.vue";
import RaderSet from "@/option/components/raderAxisCustomSet.vue";

const dialogFormVisible = ref(false)
const refSet = ref()
let props = defineProps({
  prop: {},
  main: {},
  isSub: {
    type: Boolean
  },
  isRadar: {
    type: Boolean
  },
});
const radarSet = ref()

function closeYName() {
  if (!props.prop.showYAxisName) {
    props.prop.yAxisName = ''
  }
}

const symbolKind = [
  {label: "平均值", value: "avg"},
  {label: "最大值", value: "max"},
  {
    label: "最小值",
    value: "min"
  },
  {label: "中位数", value: "mid"}]
const save = () => {
  if (props.isSub) {
    props.main.activeOption.rightReferenceCustomSet = refSet.value.getSetting()
  } else {
    props.main.activeOption.referenceCustomSet = refSet.value.getSetting()
  }
  dialogFormVisible.value = false
  // props.prop.yAxisMarkLineValue = referenceLines.value.map((i) => {
  //   return {yAxis: i.value, label: {formatter: () => i.name}}
  // })
}
const showAxisInterval = ref(false)

function openAxisInterval() {
  showAxisInterval.value = true
}

function handleOkClick() {
  props.main.activeOption.axisCustomSet = radarSet.value.getSetting()
  showAxisInterval.value = false
}

function openReference() {
  dialogFormVisible.value = true
}
</script>
<style scoped>
.checkboxAndNumber {
  display: flex;
  align-items: center;
}
</style>